import { createContext, PropsWithChildren, useContext, useState } from 'react';
import { modalComponents } from 'flow/components/modals/Modals';

interface Modal {
    name: keyof typeof modalComponents;
}

interface Context {
    closeModal: () => void;
    modals: Modal[];
    openModal: (name: keyof typeof modalComponents, props?: object) => void;
    previousModal: () => void;
}

const ModalContext = createContext({} as Context);

export const ModalProvider = ({ children }: PropsWithChildren) => {
    const [modals, setModals] = useState<Modal[]>([]);

    const closeModal = () => setModals([]);

    const openModal = (name: keyof typeof modalComponents, props = {}) =>
        setModals((old) => [...old, { ...props, name }]);

    const previousModal = () =>
        setModals((old) => old.slice(0, old.length - 1));

    return (
        <ModalContext.Provider
            value={{
                closeModal,
                modals,
                openModal,
                previousModal,
            }}
        >
            {children}
        </ModalContext.Provider>
    );
};

export const useModal = () => useContext(ModalContext);
